import React from 'react';
import {
  format,
} from 'date-fns';
import {
  StatusInfoContainer,
  ExpiredMessageContainer,
  InfoTitle,
  ExpiredMessageText,
  ClosedDateText,
  PeriodLabel,
} from './styles';
import { VirtualRaceType, UserVirtualRaceType } from '../../types/VirtualRace';
import { Activity } from '../../store/Activities.store';
import VirtualRaceActivitySummary from '../../components/VirtualRaceActivitySummary';

interface Props {
  virtualRace: VirtualRaceType,
  userVirtualRace: UserVirtualRaceType,
  allActivities: Activity[],
}

export default function VirtualRaceOutOfDate({
  virtualRace, userVirtualRace, allActivities,
}: Props) {
  const endDate = new Date(virtualRace.endDate);

  const linkedActivities = React.useMemo(() => {
    if (!userVirtualRace.activity_ids || userVirtualRace.activity_ids.length === 0) {
      return [];
    }
    return allActivities.filter((activity) => userVirtualRace.activity_ids?.includes(activity.id));
  }, [userVirtualRace.activity_ids, allActivities]);

  const totalDistance = linkedActivities.reduce((acc, activity) => acc + (activity.distance || 0), 0);
  const targetDistance = userVirtualRace.distance || 0;
  const hasInsufficientDistance = totalDistance < targetDistance;

  const formatDistance = (distance: number) => {
    const rounded = Math.round(distance * 10) / 10;
    return rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(1);
  };

  return (
    <StatusInfoContainer>
      <ExpiredMessageContainer>
        <InfoTitle>Prazo Expirado</InfoTitle>
        <ExpiredMessageText>
          {hasInsufficientDistance
            ? `O prazo de registro de atividades expirou. Você registrou ${formatDistance(totalDistance)}km, mas a distância escolhida era ${formatDistance(targetDistance)}km.`
            : 'O prazo de registro de atividades expirou e você não registrou nenhuma atividade.'}
        </ExpiredMessageText>
      </ExpiredMessageContainer>

      {linkedActivities.length > 0 && (
        <VirtualRaceActivitySummary activities={linkedActivities} />
      )}

      <PeriodLabel>PERÍODO DE REGISTRO DE ATIVIDADES</PeriodLabel>
      <ClosedDateText>
        {`Encerrado em ${format(endDate, 'dd/MM')}`}
      </ClosedDateText>
    </StatusInfoContainer>
  );
}
